export default __webpack_public_path__ + "static/media/ic-notes-attachment.27ba3b52.svg";